export const loadHTML = async (slug) => {
  const response = await fetch(`/posts/${slug}.html`);
  const text = await response.text();
  return text;
};
